import { usersEndpointIds } from 'root/src/shared/users/users.constants';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { authenticationTypes } from 'root/src/shared/constants/auth';
export const getBetaTesterStatus = {
    [usersEndpointIds.GET_BETA_TESTER_STATUS]: {
        authentication: authenticationTypes.authenticated,
        endpointType: otherEndpointType,
    },
};
